import React from "react";
import PropTypes from "prop-types";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import SectionHead from "../components/section-head";
import SEO from "../components/seo";
import Layout from "../components/layout";
import { graphql, Link } from "gatsby";
import { _ } from "../utils/i18n";

import Breadcrumbs from "../components/breadcrumbs";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import PostFilter from "../components/post-filter";
import Header from "../components/header";
import Footer from "../components/footer";

import CardContainer from "../components/card-container";
import BlogCard from "../components/blog-card";

const useStyles = makeStyles(() => ({
  span: {
    alignItems: "flex-start",
    display: "flex",
  },
}));

const BlogCat = ({ data: { wpCategory }, pageContext }) => {
  const classes = useStyles();
  return (
    <Layout>
      <div>
        <main>
          <Header
            siteTitle={wpCategory.name.replace("&amp;", "&")}
            headerColor="page"
          />
          <SEO
            title={
              wpCategory.seo?.title
                ? wpCategory.seo.title.replace("&amp;", "&")
                : wpCategory.name.replace("&amp;", "&")
            }
            description={
              wpCategory.seo?.metaDesc
                ? wpCategory.seo.metaDesc
                : wpCategory.description
            }
            canonical={wpCategory.path}
            url={wpCategory.path}
          />

          <div data-block="acf/feed">
            <Container
              maxWidth="lg"
              className="disable-padding blog-category-template"
            >
              <Breadcrumbs>
                <span
                  itemProp="itemListElement"
                  itemScope
                  itemType="http://schema.org/ListItem"
                  className={classes.span}
                >
                  <Link itemProp="item" to="/" className="breadcrumbs">
                    <span itemProp="name">{_("Hjem")}</span>
                  </Link>
                  <ArrowRightIcon className="breadcrumbs-arrow" />
                  <meta itemProp="position" content="1" />
                </span>
                <span
                  itemProp="itemListElement"
                  itemScope
                  itemType="http://schema.org/ListItem"
                  className={classes.span}
                >
                  <Link
                    itemProp="item"
                    to={
                      pageContext.type === "Post" ? _("/blogg/") : _("/case/")
                    }
                    className="breadcrumbs"
                  >
                    <span itemProp="name">
                      {pageContext.type === "Post" ? _("Blogg") : _("Case")}
                    </span>
                  </Link>
                  <meta itemProp="position" content="2" />
                  <ArrowRightIcon className="breadcrumbs-arrow" />
                </span>

                <span
                  itemProp="itemListElement"
                  itemScope
                  itemType="http://schema.org/ListItem"
                  className={`breadcrumbs ${classes.span}`}
                >
                  <span itemProp="name" className="breadcrumb-active">
                    {wpCategory.name
                      .replace("&amp;", "&")
                      .replace("&#038;", "&")}
                  </span>
                  <meta itemProp="position" content="3" />
                </span>
              </Breadcrumbs>
              <SectionHead
                title={pageContext.type === "Post" ? _("Blogg") : _("Case")}
              />
              <PostFilter
                current={wpCategory.name}
                input="button"
                isSub={true}
                type={pageContext.type.toLowerCase()}
              />
              <div className="feed">
                <CardContainer itemType="Blog">
                  {wpCategory.contentNodes?.nodes
                    ?.filter((node) => node.nodeType === pageContext.type)
                    ?.map((node, i) => (
                      <BlogCard
                        key={i}
                        imgSize="small"
                        imgUrl={node.featuredImage?.node?.sourceUrl}
                        link={`${pageContext.type !== "Case" ? "" : ""}${
                          node.uri
                        }`}
                        date={node.date}
                        category={node.categories?.nodes?.[0].name}
                        linkCategory={node.categories?.nodes?.[0]?.uri}
                        title={node.title}
                      />
                    ))}
                </CardContainer>
              </div>
            </Container>
          </div>
          <Footer />
        </main>
      </div>
    </Layout>
  );
};

BlogCat.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default BlogCat;

export const query = graphql`
  query ($id: Int!) {
    wpCategory(databaseId: { eq: $id }) {
      name
      uri
      description
      seo {
        metaDesc
        title
      }
      contentNodes {
        nodes {
          date(formatString: "MMMM DD, YYYY")
          id
          contentTypeName
          nodeType
          slug
          uri
          ... on WpPost {
            categories {
              nodes {
                name
                uri
              }
            }
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
            title
          }
          ... on WpCase {
            categories {
              nodes {
                name
                uri
              }
            }
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
            title
          }
        }
      }
    }
  }
`;
